import styled from '@emotion/styled';

import { capitalizeWords } from '../../../utils/utils';

interface TableNameCapitalizeFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableNameCapitalizeFormatter: React.FC<
  TableNameCapitalizeFormatterProps
> = ({ data, dataKey, className }) => {
  const label = data && data[dataKey ?? ''];
  return (
    <Container className={className}>
      {label ? capitalizeWords(String(label)) : <EmptyCell>N/A</EmptyCell>}
    </Container>
  );
};

export default TableNameCapitalizeFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;

const EmptyCell = styled.div`
  color: ${({ theme }) => theme.palette.tertiaryTextColor};
  font-size: 14px;
  font-weight: 700;
  padding: 16px;
  text-align: left;
`;
